import React from 'react';
import { components } from 'react-select';

const ValueContainer = ({ children, ...props }) => {
  const exclusiveOption = (props.getValue() || []).find(({ isExclusive }) => isExclusive);
  let childrenToRender = children;

  if (exclusiveOption) {
    childrenToRender = (
      <components.SingleValue {...props} data={exclusiveOption}>{exclusiveOption.label}</components.SingleValue>
    );
  }

  return (
    <components.ValueContainer {...props} isMulti={!exclusiveOption}>
      {childrenToRender}
    </components.ValueContainer>
  );
};

export default ValueContainer;
